import WebStoragePolyfill from './webstorage-polyfill';

export default [
  'CustomerService', 'CartService',
  class AbandonedCartService {
    constructor (customerService, cartService) {
      this._customerService = customerService;
      this._storage = new WebStoragePolyfill();

      this.cart = cartService;
    }

    trackAbandonedCart (email) {
      this._storeEmail(email);
      this.cart.ready
        .then(() => {
          let pid = this._getFirstProductId();
          return this._customerService.trackAbandonedCart(email, this.cart.campaign.id, pid, this._getHash());
        })
        .then((res) => this._storeHash(res['cart_hash']));
    }

    trackNewCart () {
      let email = this._getEmail();
      if (email) this.trackAbandonedCart(email);
    }

    convertTrackedCart (email, orderNum) {
      this.cart.ready
        .then(() => this._customerService.convertTrackedCart(email, this.cart.campaign.id, orderNum));
    }

    optOutCart (hash) {
      return this._customerService.optOutCart(hash);
    }

    _getFirstProductId () {
      return this.cart.contents()[0].cpid;
    }

    _storeHash (hash) {
      this._storage.setLocalItem(`cartHash:${this.cart.campaign.id}`, hash);
    }

    _getHash () {
      return this._storage.getLocalItem(`cartHash:${this.cart.campaign.id}`);
    }

    _storeEmail (email) {
      this._storage.setLocalItem('userEmail', email);
    }

    _getEmail () {
      return this._storage.getLocalItem('userEmail');
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/data-providers/abandoned-cart.js